import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DOMAIN_ORGANIZATION, DOMAIN_ORGANIZATION_LOWER, DOMAIN_SEASON, DOMAIN_SEASON_LOWER } from '../../constants/domainCopy';

import { IconButton } from '../buttons-visuals';
import { Popover } from '../overlays/popovers';

interface TennisStyleSetsPopoverProps {
    showSeasonStartedWarning?: boolean;
}

const TennisStyleSetsPopover = ({ showSeasonStartedWarning }: TennisStyleSetsPopoverProps) => {
    

    return (
        <Popover
            button={
                <IconButton as="button" buttonLabel="More info" buttonSize="small">
                    <FontAwesomeIcon icon={['fas', 'circle-info']} />
                </IconButton>
            }
            className="mt"
        >
            <p className="p text-small mb0">How many games should each player play?</p>

            {!!showSeasonStartedWarning && (
                <p className="p text-small weight-700">
                    This setting cannot be changed after the {DOMAIN_SEASON} has started.
                </p>
            )}
        </Popover>
    );
};

export default TennisStyleSetsPopover;
